import { ChangeDetectionStrategy, Component, computed, inject, model, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { HmiLookupService } from '../pano/pages/personel/services/hmi-lookup.service';
import { SISTEM_PARAMETRE_SETLERI } from '@service/fikoyt-ui/src/lib/parametre-setleri/sistem-parametre-setleri';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'cam-parca-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule, NzDividerModule, NzIconModule, NzDatePickerModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="se">
      <div class="se-baslik">
        <div class="se-baslik-ikon" style="background:linear-gradient(135deg,#0891b2,#06b6d4)">🔷</div>
        <span>Cam Parça</span>
      </div>
      <div class="se-form">
        <div class="form-grup">
          <label>Parça Adı <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <input nz-input autocomplete="off"
              [ngModel]="p()?.parcaAdi || ''" (ngModelChange)="guncelle('parcaAdi', $event)"
              placeholder="Parça adını girin..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-satir">
          <div class="form-grup" style="flex:0 0 90px">
            <label>Revizyon</label>
            <div class="input-wrap">
              <input nz-input [ngModel]="p()?.revizyon || 'v1'" (ngModelChange)="guncelle('revizyon', $event)" placeholder="v1" style="text-align:center;font-weight:700"/>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:0 0 130px">
            <label>Tolerans</label>
            <div class="input-wrap">
              <input nz-input [ngModel]="p()?.tolerans || ''" (ngModelChange)="guncelle('tolerans', $event)" placeholder="±0.1 mm"/>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup" style="flex:1">
            <label>En (mm)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.en || null" (ngModelChange)="guncelle('en', $event)"
                [nzMin]="0" [nzStep]="1" nzPlaceHolder="En" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:1">
            <label>Boy (mm)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.boy || null" (ngModelChange)="guncelle('boy', $event)"
                [nzMin]="0" [nzStep]="1" nzPlaceHolder="Boy" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:1">
            <label>Yükseklik (mm)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.yukseklik || null" (ngModelChange)="guncelle('yukseklik', $event)"
                [nzMin]="0" [nzStep]="1" nzPlaceHolder="Yükseklik" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
        @if (hacim()) {
          <div style="padding:6px 12px;background:rgba(8,145,178,.08);border-radius:8px;margin-top:4px;display:flex;align-items:center;gap:8px">
            <span style="font-size:11px;color:var(--py-metin-ucuncul)">Hacim:</span>
            <span style="font-size:14px;font-weight:700;color:#0891b2">{{ hacim() }}</span>
          </div>
        }

        <div class="se-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup" style="flex:1">
            <label>Malzeme</label>
            <div class="input-wrap">
              <nz-select [ngModel]="p()?.malzeme" (ngModelChange)="guncelle('malzeme', $event)"
                nzPlaceHolder="Malzeme seçin..." nzAllowClear nzShowSearch nzNotFoundContent="Malzeme bulunamadı" style="width:100%"
                (nzOnSearch)="malzemeAra($event)" [nzDropdownRender]="malzemeFooterTpl">
                @for (m of lookup.malzemeler(); track m._id) {
                  <nz-option [nzValue]="m.malzemeAdi" [nzLabel]="m.malzemeAdi" nzCustomContent>
                    <div class="sel-item"><span class="sel-emoji">🧊</span>
                      <div class="sel-bilgi"><span class="sel-ad">{{ m.malzemeAdi }}</span>
                        @if (m.pilesmi || m.kalinlik) { <span class="sel-detay">{{ m.pilesmi }}@if (m.kalinlik) { · {{ m.kalinlik }}mm }</span> }
                      </div>
                    </div>
                  </nz-option>
                }
              </nz-select>
              <ng-template #malzemeFooterTpl>
                <nz-divider style="margin:4px 0"></nz-divider>
                <div class="aku-hizli-ekle" (mousedown)="$event.preventDefault()" (click)="yeniMalzemeEkle()">
                  <nz-icon nzType="plus" /> Yeni Malzeme Ekle
                </div>
              </ng-template>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:0 0 100px">
            <label>Adet</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.adet || 1" (ngModelChange)="guncelle('adet', $event)"
                [nzMin]="1" [nzStep]="1" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:0 0 130px">
            <label>Öncelik</label>
            <div class="input-wrap">
              <nz-select [ngModel]="p()?.oncelik || 'Normal'" (ngModelChange)="guncelle('oncelik', $event)" style="width:100%">
                <nz-option nzValue="Düşük" nzLabel="Düşük" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#8c8c8c"></span> Düşük</span></nz-option>
                <nz-option nzValue="Normal" nzLabel="Normal" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#1890ff"></span> Normal</span></nz-option>
                <nz-option nzValue="Yüksek" nzLabel="Yüksek" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#fa8c16"></span> Yüksek</span></nz-option>
                <nz-option nzValue="Acil" nzLabel="Acil" nzCustomContent><span style="display:inline-flex;align-items:center;gap:6px"><span class="sel-dot" style="background:#ff4d4f"></span> Acil</span></nz-option>
              </nz-select>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Sipariş</label>
          <div class="input-wrap">
            <nz-select [ngModel]="p()?.siparisRef" (ngModelChange)="guncelle('siparisRef', $event)"
              nzPlaceHolder="Sipariş bağla..." nzAllowClear nzShowSearch style="width:100%"
              (nzOnSearch)="siparisAra($event)">
              @for (s of lookup.siparisler(); track s._id) {
                <nz-option [nzValue]="s.siparisNo || s._id" [nzLabel]="s.siparisNo || 'Sipariş'" nzCustomContent>
                  <div class="sel-item"><span class="sel-emoji">🛒</span>
                    <div class="sel-bilgi"><span class="sel-ad">{{ s.siparisNo || 'Sipariş' }}</span>
                      @if (s.musteri || s.urunAdi) { <span class="sel-detay">{{ s.musteri }}@if (s.urunAdi) { · {{ s.urunAdi }} }</span> }
                    </div>
                  </div>
                </nz-option>
              }
            </nz-select>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Hedef Bitiş Tarihi</label>
          <div class="input-wrap">
            <nz-date-picker [ngModel]="p()?.hedefTarih" (ngModelChange)="guncelle('hedefTarih', $event)"
              nzPlaceHolder="Teslim tarihi..." nzShowTime style="width:100%"></nz-date-picker>
            <div class="input-glow"></div>
          </div>
          @if (gecikmeGun() !== null) {
            <div class="stok-uyari" [class.stok-uyari--tehlike]="gecikmeGun()! <= 0" [class.stok-uyari--uyari]="gecikmeGun()! > 0 && gecikmeGun()! <= 3">
              {{ gecikmeGun()! <= 0 ? '⛔ GECİKME: ' + (-gecikmeGun()!) + ' gün geçti!' : '⏰ ' + gecikmeGun() + ' gün kaldı' }}
            </div>
          }
        </div>

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Notlar</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off"
              [ngModel]="p()?.notlar || ''" (ngModelChange)="guncelle('notlar', $event)"
              placeholder="Notlar..." cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4"></textarea>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrl: './cam-edit.styles.less',
})
export class CamParcaEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  lookup = inject(HmiLookupService);
  private modal = inject(NzModalService);
  private vcr = inject(ViewContainerRef);

  constructor() { super(); this.lookup.malzemeleriYukle(); this.lookup.siparisleriYukle(); }

  p = computed(() => this.parametreler()?.ek || {});

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) { params.ek[alan] = deger; this.parametreler.set({ ...params }); }
  }

  malzemeAra(terim: string) { this.lookup.malzemeleriYukle(terim); }
  siparisAra(terim: string) { this.lookup.siparisleriYukle(terim); }
  hacim = computed(() => {
    const en = +(this.p()?.en || 0), boy = +(this.p()?.boy || 0), yuk = +(this.p()?.yukseklik || 0);
    if (!en || !boy || !yuk) return null;
    const mm3 = en * boy * yuk;
    return mm3 >= 1000000 ? (mm3 / 1000000000).toFixed(2) + ' dm³' : (mm3 / 1000).toFixed(1) + ' cm³';
  });
  gecikmeGun = computed(() => {
    const hedef = this.p()?.hedefTarih;
    if (!hedef) return null;
    const fark = new Date(hedef).getTime() - Date.now();
    return Math.ceil(fark / 86400000);
  });

  async yeniMalzemeEkle() {
    const { PaylasKutusuComponent } = await import('@service/fikoyt-ui/src/lib/paylasim-sistemi/paylas-kutusu/paylas-kutusu.component');
    const camGrubu = SISTEM_PARAMETRE_SETLERI.find(g => g.id === 'sistem.cam-isleme');
    const malzemeSet = camGrubu?.altGruplar?.find((s: any) => s.id === 'cam.malzeme-tanimi');
    if (!malzemeSet) return;

    const setKopya = JSON.parse(JSON.stringify(malzemeSet));
    const kart: any = {
      _id: Date.now().toString(36),
      vt: 'FikoYT.sistem.hareketler',
      yol: 'FikoYT.sistem.hareketler.kalem',
      turu: 'KART',
      gizlilik: 'Herkese Açık',
      uygulama: [],
      veri: { solSimge: { baslik: '🧊', renkArka: '#0e7490', renkYazi: '#fff' }, icerikler: [{
        _id: Date.now().toString(36), html: '', aciklama: '', sifre: null,
        ek: { turu: 'UYGULAMAICERIK', _secilenSetId: setKopya.id, parametreler: setKopya.parametreler || [], ...(setKopya.bilesen ? { bilesen: setKopya.bilesen } : {}) }
      }] },
    };

    const setleri = [JSON.parse(JSON.stringify(malzemeSet))];
    const ref = this.modal.create({
      nzTitle: '🧊 Yeni Malzeme Tanımı',
      nzContent: PaylasKutusuComponent,
      nzWidth: 520,
      nzFooter: null,
      nzViewContainerRef: this.vcr,
    });
    ref.afterOpen.subscribe(() => {
      const inst = ref.componentInstance;
      if (!inst) return;
      inst.kart = kart;
      inst.parametreSetleri = setleri;
      inst.parametreSetiZorunlu = true;
      inst.taslakDevreDisi = true;
      inst.paylasimYapildi?.subscribe(() => {
        ref.close();
        this.lookup.malzemeleriYukle('', true);
        this.nzNotification.success('Malzeme Eklendi', 'Yeni malzeme tanımı kaydedildi');
      });
      inst.CD?.detectChanges?.();
    });
  }
}
